import { useEffect, useState } from "react";
import { IoArrowBackSharp } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FiUpload } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import capitalizeFirstLetter from "../../comman/capitalizeFirstLetter";
import { fetchCustomerAddress } from "../../../redux/actions/customerAddress";
import axios from "axios";

const Base_Url = process.env.REACT_APP_BASE_URL;

export default function BookOne() {
  const location = useLocation();
  const { id, title } = location.state || {};

  useEffect(() => {
  if (id && title) {
    setCurrentItem((prev) => ({
      ...prev,
      name: id,
    }));
  }
}, [id, title]);

  const [itemErrors, setItemErrors] = useState({});
  const [selectedAddress,setSelectedAddress]=useState(null);

  const [loading, setLoading] = useState(false);
  const { address, error } = useSelector(
    (state) => state.customerAddressState
  );
  const dispatch=useDispatch();

  useEffect(() => {
      const fetchData = async () => {
        try {
          setLoading(true);
          dispatch(fetchCustomerAddress()); 
        } finally {
          setLoading(false);
        }
      };
    
      fetchData();
  }, [dispatch]);

  const formatAddress = (addr) => {
  if (!addr) return "";
  return [
    addr.buildingBlock ? addr.buildingBlock.toUpperCase() : "",
    addr.flatNo || "",
    addr.buildingName || "",
    addr.landmark || "",
    addr.streetName || "",
    addr.city || "",
    addr.pincode || ""
  ]
    .filter(Boolean) 
    .join(", ");
  };

  const [items, setItems] = useState([]);

  const [currentItem, setCurrentItem] = useState({
    name:id,
    device_type: "",
    brand_name: "",
    model_number: "",
    problem_description: "",
    issue_start_date: "",
    warranty_status: "",
    noOfDevices:"",
    issue_photos: [],
  });
  const [commonData, setCommonData] = useState({ 
    location: "",
    pickup_required: "",
    pickupDate: "",
    preferred_date:"",
    preferred_time_slot:"",
    additionalNote:"",
  });

  const isDeviceAdded = items.length > 0;

  const navigate=useNavigate();

  const handleItemChange = (e) => {
  const { name, value, type } = e.target;

  if (type === "file") {
    const newFiles = Array.from(e.target.files);

    setCurrentItem((prev) => {
      const combinedFiles = [...prev[name], ...newFiles];

      if (combinedFiles.length > 5) {
        toast.warn("You can only upload up to 5 images.");
        return prev; 
      }

      return {
        ...prev,
        [name]: combinedFiles,
      };
    });
  } else {
    setCurrentItem((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
};

  const handleCommonChange = (e) => {
    const { name, value } = e.target;
    setCommonData({ ...commonData, [name]: value });
  };
  
  const handleAddItem = () => {
  const errors = {};

  if (!currentItem.device_type) errors.device_type = "Device type is required";
  if (!currentItem.brand_name) errors.brand_name = "Brand name is required";
  if (!currentItem.model_number) errors.model_number = "Model number is required";
  if (!currentItem.problem_description) errors.problem_description = "Problem description is required";
  if (!currentItem.issue_start_date) {
    errors.issue_start_date = "Issue start date is required";
  } else {
    const today = new Date();
    today.setHours(0, 0, 0, 0); 
    const issueDate = new Date(currentItem.issue_start_date);
    issueDate.setHours(0, 0, 0, 0);

    if (issueDate > today) {
      errors.issue_start_date = "Issue start date cannot be in the future";
    }
  }
  if (!currentItem.noOfDevices) {
  errors.noOfDevices = "Number of devices is required";
} else if (!/^\d+$/.test(currentItem.noOfDevices)) {
  errors.noOfDevices = "Number of devices must be a valid number";
}
  if (!currentItem.warranty_status) errors.warranty_status = "Warranty status is required";
  if (currentItem.issue_photos.length === 0) errors.issue_photos = "Please upload at least 1 photo";

  if (Object.keys(errors).length > 0) {
    setItemErrors(errors);
    toast.error("Fix the highlighted errors");
    return;
  }
  setItems([...items, currentItem]);
  setCurrentItem({
    name:"",
    noOfDevices:"",
    device_type: "",
    brand_name: "",
    model_number: "",
    problem_description: "",
    issue_start_date: "",
    warranty_status: "",
    issue_photos: [],
  });
  setItemErrors({}); 
  };

  const handleDeleteItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
  };

  const validateForm = () => {
  
  
  if (items.length === 0) {
    toast.error("Please add at least one device");
    return false;
  }

  if (commonData.preferred_date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const serviceDate = new Date(commonData.preferred_date);

    if (serviceDate < today) {
      toast.error("Preferred service date cannot be in the past");
      return false;
    }
  }

  if (!commonData.pickup_required) {
    toast.error("Please select Pickup Required option");
    return false;
  }

  if (commonData.pickup_required === "Yes" && !commonData.pickupDate) {
    toast.error("Pickup Date is required when pickup is Yes");
    return false;
  }

  if (commonData.pickupDate) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const pickupDate = new Date(commonData.pickupDate);

    if (pickupDate < today) {
      toast.error("Pickup date cannot be in the past");
      return false;
    }

    if (commonData.preferred_date) {
      const serviceDate = new Date(commonData.preferred_date);
      if (serviceDate <= pickupDate) {
        toast.error("Service date must be after pickup date");
        return false;
      }
    }
  }

  if (commonData.pickup_required === "Yes" && !commonData.preferred_time_slot) {
    toast.error("Pickup time is required when pickup is Yes");
    return false;
  }

  if (!selectedAddress) {
    toast.error("Please select an address");
    return false;
  }

  return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 

    const formData = new FormData();
    formData.append("addressId", selectedAddress);
    formData.append("preferredServiceDate", commonData.preferred_date);
    formData.append("pickupRequired", commonData.pickup_required === "Yes");
    if (commonData.pickup_required === "Yes") {
      formData.append("pickupDate", commonData.pickupDate || "");
      formData.append("pickupTimeSlot", commonData.preferred_time_slot || "");
    } else {
      formData.append("pickupDate", "");
      formData.append("pickupTimeSlot", "");
    }
    formData.append("additionalNotes", commonData.additionalNote || "");

    formData.append(
    "items",
    JSON.stringify(
      items.map((item) => ({
        serviceId: Number(item.name),
        deviceType: item.device_type,
        brandName: item.brand_name,
        modelNumber: item.model_number,
        warranty: item.warranty_status,
        noOfDevices: Number(item.noOfDevices),
        issueStartDate: item.issue_start_date,
        problemDescription: item.problem_description,
      }))
    )
  );

  items.forEach((item, index) => {
    item.issue_photos.forEach((file) => {
      formData.append(`image[${index}]`, file);
    });
  });
  try {
    setLoading(true);
    const token = localStorage.getItem("token");

    const response = await axios.post(`${Base_Url}/api/bookedService/bookService`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data.success) {
      toast.success(response.data.message || "Service booked successfully!");
      setItems([]);
      setCurrentItem({
        name: "",
        device_type: "",
        brand_name: "",
        model_number: "",
        problem_description: "",
        issue_start_date: "",
        warranty_status: "",
        noOfDevices: "",
        issue_photos: [],
      });
      setCommonData({
        location: "",
        pickup_required: "",
        pickupDate: "",
        preferred_date: "",
        preferred_time_slot: "",
        additionalNote: "",
      });
      setSelectedAddress(null);
      setItemErrors({});
    } else {
      toast.error(response.data.message || "Failed to book service");
    }
  } catch (error) {
    console.error(error);
    toast.error(error.response?.data?.message || "Something went wrong.");
  } finally {
    setLoading(false);
  }
  };

  const { service } = useSelector(
    (state) => state.serviceState
  );

  if(error)
    {
      return(
        <p className="text-red-600">Address error : {error}</p>
      );
  }

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-7xl mx-auto space-y-6 shadow bg-gray-100 p-3 md:p-5">    
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 text-xs md:text-sm xl:text-base">
        
        <div className="flex flex-row w-full items-start xl:items-center text-base md:text-lg xl:text-xl font-medium text-opacity-95 space-x-2" onClick={()=>navigate(-1)}>
          <IoArrowBackSharp className="text-xl md:text-2xl xl:text-xl"/>
          <p>Book Your Repair Service – Share Your Device Details</p>
        </div>

        <div className={`flex flex-col md:flex-row items-center border p-3 rounded-md 
          ${id && currentItem.name ? "border-yellow-400 bg-yellow-100" : "border-gray-300 bg-gray-50"}`}>
          <label className="block w-full md:w-1/3 mb-1 md:mb-0">Select service you want</label>
          <select
            name="name"
            value={currentItem.name}
            onChange={handleItemChange}
            disabled={!!id && items.length === 0} 
            className="border rounded-md border-gray-400 focus:outline-none px-0 md:px-4 py-2 w-full md:w-2/3 bg-white"
          >
            <option value="">Select Service</option>
              {service.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {capitalizeFirstLetter(cat.serviceName)}
                </option>
              ))}
          </select>
        </div>

        <h2 className="text-lg font-semibold md:col-span-2">Add your device</h2>
            
        <div className="w-full">
          <label className="block mb-1">Device Type<span className="text-red-500 pl-1 text-xs md:text-sm xl:text-base font-medium">*</span></label>
          <select
            name="device_type"
            value={currentItem.device_type}
            onChange={handleItemChange}
            className="w-full border rounded-md border-gray-400 focus:outline-none px-4 py-2"
          >
            <option value="">Select Device</option>
            <option value="Laptop">Laptop</option>
            <option value="Desktop">Desktop</option>
            <option value="Other">Other</option>
          </select>
            {itemErrors.device_type && (
              <p className="text-red-500 text-xs mt-1">{itemErrors.device_type}</p>
            )}
        </div>

        <div className="w-full">
          <label className="block mb-1">Brand Name<span className="text-red-500 pl-1 text-xs md:text-sm xl:text-base font-medium">*</span></label>
          <input
            type="text"
            name="brand_name"
            value={currentItem.brand_name}
            onChange={handleItemChange}
            placeholder="e.g., Dell, HP"
            className="w-full border rounded-md border-gray-400 focus:outline-none px-4 py-2"
            
          />
           {itemErrors.brand_name && (
              <p className="text-red-500 text-xs mt-1">{itemErrors.brand_name}</p>
            )}
        </div>

        <div className="w-full">
          <label className="block mb-1">Model Number<span className="text-red-500 pl-1 text-xs md:text-sm xl:text-base font-medium">*</span></label>
          <input
            type="text"
            name="model_number"
            value={currentItem.model_number}
            onChange={handleItemChange}
            placeholder="e.g., Inspiron 15"
            className="w-full border rounded-md border-gray-400 focus:outline-none px-4 py-2"
          
          />
           {itemErrors.model_number && (
              <p className="text-red-500 text-xs mt-1">{itemErrors.model_number}</p>
            )}
        </div>

        <div className="w-full">
          <label className="block mb-1">Is the device under warranty?<span className="text-red-500 pl-1 text-xs md:text-sm xl:text-base font-medium">*</span></label>
          <div className="flex gap-4">
            {["Yes", "No", "Not Sure"].map((option) => (
              <label key={option} className="flex gap-2 items-center">
                <input
                  type="radio"
                  name="warranty_status"
                  value={option}
                  onChange={handleItemChange}
                  checked={currentItem.warranty_status === option}
                />
                  {option}
              </label>
            ))}
          </div>
           {itemErrors.warranty_status && (
              <p className="text-red-500 text-xs mt-1">{itemErrors.warranty_status}</p>
            )}
        </div>

        <div className="w-full">
          <label className="block mb-1">When did the issue start?<span className="text-red-500 pl-1 text-xs md:text-sm xl:text-base font-medium">*</span></label>
          <input
            type="date"
            name="issue_start_date"
            value={currentItem.issue_start_date}
            onChange={handleItemChange}
            className="w-full border rounded-md border-gray-400 focus:outline-none px-4 py-2"
          />
           {itemErrors.issue_start_date && (
              <p className="text-red-500 text-xs mt-1">{itemErrors.issue_start_date}</p>
            )}
        </div>

        <div className="w-full">
          <label className="block mb-1">Number of devices<span className="text-red-500 pl-1 text-xs md:text-sm xl:text-base font-medium">*</span></label>
          <input
            type="text"
            name="noOfDevices"
            value={currentItem.noOfDevices}
            onChange={handleItemChange}
            placeholder="e.g., 1,10,15 etc"
            className="w-full border rounded-md border-gray-400 focus:outline-none px-4 py-2"
            min="1"
          />
           {itemErrors.noOfDevices && (
              <p className="text-red-500 text-xs mt-1">{itemErrors.noOfDevices}</p>
            )}
        </div>

        <div className="w-full">
          <label className="block mb-1">Problem Description<span className="text-red-500 pl-1 text-xs md:text-sm xl:text-base font-medium">*</span></label>
          <textarea
            name="problem_description"
            value={currentItem.problem_description}
            onChange={handleItemChange}
            rows={2}
            placeholder="Describe the issue"
            className="w-full border rounded-md border-gray-400 focus:outline-none px-4 py-2"
          />
           {itemErrors.problem_description && (
              <p className="text-red-500 text-xs mt-1">{itemErrors.problem_description}</p>
            )}
        </div>

        <div className="w-full flex flex-col md:flex-row gap-2 md:gap-4 md:col-span-2">
          <div className="w-full md:w-1/3">
            <label className="block mb-2 font-medium text-gray-700">Upload Photos<span className="text-red-500 pl-1 text-xs md:text-sm xl:text-base font-medium">*</span></label>

            <label className="flex flex-col items-center justify-center border-2 border-dashed border-[#A63F40] rounded-md p-2 xl:p-4 cursor-pointer hover:border-gray-400 transition-all">
              <FiUpload className="text-3xl text-gray-500 mb-2" />
              <p className=" text-gray-500 text-center">Click to upload images</p>
    
              <input
                type="file"
                name="issue_photos"
                multiple
                accept="image/*"
                onChange={handleItemChange}
                className="hidden"
              />
            </label>
             {itemErrors.issue_photos && (
              <p className="text-red-500 text-xs mt-1">{itemErrors.issue_photos}</p>
            )}
          </div>

          {currentItem.issue_photos.length > 0 && (
            <div className="flex flex-row gap-1 md:gap-4 w-full md:w-2/3 md:pt-8 xl:pt-10">
            {currentItem.issue_photos.map((file, index) => (
              <div key={index} className="relative w-14 h-14 md:w-16 md:h-16 xl:h-20 xl:w-20">
                <img
                  src={URL.createObjectURL(file)}
                  alt={`preview-${index}`}
                  className="w-full h-full object-cover rounded border"
                />
                <button
                  type="button"
                  onClick={() => {
                  setCurrentItem((prev) => {
                  const updatedFiles = [...prev.issue_photos];
                  updatedFiles.splice(index, 1);
                  return {
                    ...prev,
                    issue_photos: updatedFiles,
                  };
                  });
                  }}
                  className="absolute top-0 right-0 bg-red-500 text-white text-center rounded-full w-4 h-4 text-xs"
                >
                  ×
                </button>
              </div>
            ))}
            </div>
              )}
        </div>   

      </div>

      <div className="flex justify-end">
        <button
          type="button"
          onClick={handleAddItem}
          className="bg-[#A63F40] text-white px-4 py-2 rounded"
        >
          Add Item
        </button>
      </div>
      

      {items.length > 0 && (
      <div className="border border-gray-400 rounded-md mt-4">
        <table className="w-full table-fixed">
          <thead className="bg-white ">
            <tr className="py-2">
              <th className="w-10 py-2 rounded-tl-lg">Service Name</th>
              <th className="py-2 w-10">Device Type</th>
              <th className="py-2 w-10">Brand</th>
              <th className="py-2 w-10">Model</th>
              <th className="py-2 w-10">Issue Start Date</th>
              <th className="py-2 w-10">No of devices</th>
              <th className="py-2 w-10">In Warranty?</th>
              <th className="py-2 w-24">Problem</th>
              <th className="py-2 w-6 rounded-tr-md">Action</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, i) => (
              <tr key={i}>
                <td className="border-t border-gray-400 py-2 pl-4 break-words whitespace-normal">
                  {service.find(s => s.id === Number(item.name))?.serviceName || "—"}
                </td>

                <td className="border-t border-gray-400 py-2 pl-4 break-words whitespace-normal">{item.device_type}</td>
                <td className="border-t border-gray-400 py-2 pl-10 break-words whitespace-normal">{item.brand_name}</td>
                <td className="border-t border-gray-400 py-2 pl-8 break-words whitespace-normal">{item.model_number}</td>
                <td className="border-t border-gray-400 py-2 pl-6 break-words whitespace-normal">{item.issue_start_date}</td>
                <td className="border-t text-center border-gray-400 py-2 pl-4 break-words whitespace-normal">{item.noOfDevices}</td>
                <td className="border-t border-gray-400 py-2 pl-4 break-words whitespace-normal">{item.warranty_status}</td>
                <td className="border-t border-gray-400 py-2 text-center break-words whitespace-normal">{item.problem_description}</td>
                <td className="border-t border-gray-400 py-2 text-center">
                  <button
                    type="button"
                    onClick={() => handleDeleteItem(i)}
                    className="text-red-500 text-lg"
                  >
                    <MdDelete/>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      )}

      <fieldset disabled={!isDeviceAdded} className={!isDeviceAdded ? "opacity-50" : ""}>
      <h2 className="text-lg font-semibold mt-6 pb-3">General Details</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-xs md:text-sm xl:text-base">
          <div className="w-full">
            <label className="block mb-1">Preferred Service Date<span className="text-red-500 pl-1 text-xs md:text-sm xl:text-base font-medium">*</span></label>
            <input
              type="date"
              name="preferred_date"
              value={commonData.preferred_date}
              onChange={handleCommonChange}
              className="w-full border rounded-md border-gray-400 focus:outline-none px-4 py-2"
              required
            />
          </div>

          <div className="w-full">
            <label className="block mb-1">Pickup & Drop Required?<span className="text-red-500 pl-1 text-xs md:text-sm xl:text-base font-medium">*</span></label>
            <div className="flex gap-4">
              {["Yes", "No"].map((option) => (
              <label key={option} className="flex gap-2 items-center">
              <input
              type="radio"
              name="pickup_required"
              value={option}
              onChange={handleCommonChange}
              />
                {option}
              </label>
              ))}
            </div>
          </div>

          <div className="w-full">
              <label className="block mb-1">Select pickup Service Date</label>
              <input
                type="date"
                name="pickupDate"
                onChange={handleCommonChange}
                className={`w-full border rounded-md px-4 py-2 focus:outline-none ${
                commonData.pickup_required !== "Yes"
                ? "bg-gray-200 cursor-not-allowed"
                : "border-gray-400"
                }`}
                required={commonData.pickup_required === "Yes"}
                disabled={commonData.pickup_required !== "Yes"}
               />
          </div>

          <div className="w-full">
            <label className="block mb-1">Select pickup Time Slot</label>
            <select
              name="preferred_time_slot"
              value={commonData.preferred_time_slot}
              onChange={handleCommonChange}
              className={`w-full border rounded-md px-4 py-2 focus:outline-none ${
              commonData.pickup_required !== "Yes"
              ? "bg-gray-200 cursor-not-allowed"
              : "border-gray-400"
              }`}
              required={commonData.pickup_required === "Yes"}
              disabled={commonData.pickup_required !== "Yes"}
            >
              <option value="">Select Slot</option>
              <option value="10:30 AM - 12:30 PM">10:30 AM - 12:30 PM</option>
              <option value="01:00 PM - 03:00 PM">01:00 PM - 03:00 PM</option>
              <option value="04:00 PM - 06:00 PM">04:00 PM - 06:00 PM</option>
              <option value="07:00 PM - 09:00 PM">07:00 PM - 09:00 PM</option>
            </select>
          </div>


          <div className="w-full md:col-span-2">
            <label className="block mb-1">Additional Notes</label>
            <textarea
              name="additionalNote"
              onChange={handleCommonChange}
              rows={2}
              placeholder="Any other info or requests"
              className="w-full border rounded-md border-gray-400 focus:outline-none px-4 py-2"
            />
          </div>


      </div>
      
      <h2 className="text-lg font-semibold mt-6 pb-3">Select Address</h2>
      <div className="bg-white rounded-md shadow-md w-full p-3 md:p-5">
          <p className="text-sm md:text-base xl:text-lg font-medium pb-2">Saved Address<span className="text-red-500 pl-1 text-xs md:text-sm xl:text-base font-medium">*</span></p>

          <div className="border border-gray-500 rounded p-4 space-y-3 text-xs md:text-sm xl:text-base">
            {loading? (
              <p className="text-center">Loading addresses</p>
            ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-2">
            {address.length===0?(
              <p className="text-center col-span-full text-red-600 font-semibold py-8">
                  No Address add yet.
              </p>
            ) : (
            address.map((address, index) => (
            <label key={index} className="flex items-center space-x-2">
              <input
                type="radio"
                name="delivery"
                checked={selectedAddress === address.id}
                onChange={() => setSelectedAddress(address.id)}
                className="accent-[#A63F40] cursor-pointer"
              />
              <span className="break-words cursor-pointer">
                {formatAddress(address)}
              </span>
            </label>
            )))}
            </div>
           )}
            {/* <div className="flex justify-center">
              <button className="mt-4 text-[#A63F40] px-5 py-2 border border-[#A63F40] rounded-md text-xs md:text-sm xl:text-base"
              onClick={() => setOpen(true)}>+ Add New Address</button>
            </div> */}
          </div>
      </div>

      <div className="flex flex-row justify-end pt-3">
          <button
            type="submit"
            className="bg-green-500 text-white px-6 py-2 rounded"
          >
            Submit
          </button>
      </div>
      </fieldset>
      
      {/* <AddressModal isOpen={open} onClose={() => setOpen(false)} /> */}
    </form>
  );
}
